
import {defineComponent, PropType} from 'vue'
import ItemIcons from "@/components/layouts/pim/PimProductsOverviewItemIcons.vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import {
  CatalogProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductWithImageOverviewRestDtoModel";

export default defineComponent({
  name: "ProductSelectorLine",
  components: {InputCheckboxBoolean, ItemIcons},
  emits: ['selectProduct', 'checkProduct'],
  props: {
    product: {
      type: Object as PropType<CatalogProductWithImageOverviewRestDtoModel>,
      required: true
    },
    singleProduct: {
      type: Boolean,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selected: false,
    }
  },
  computed: {},
  methods: {
    checkboxSelected(): void {
      this.$emit("checkProduct", {
        product: this.product,
        selected: this.selected
      });
    },
    selectProduct(): void {
      if (this.singleProduct) {
        this.$emit('selectProduct', this.product);
      } else {
        this.selected = !this.selected;
        this.checkboxSelected();
      }
    },
  }
})
